import { Inject, Injectable } from '@angular/core';
import { HttpRequest } from '@angular/common/http';
import { assign, isEmpty, map, reduce, some } from 'lodash';
import { Observable } from 'rxjs/Observable';

import { AUTH_PROVIDERS, AuthProvider, REDIRECT_URL } from '../providers/auth.provider';
import { IdleService } from './idle.service';
import { User } from '~auth/model';

@Injectable()
export class AuthService implements AuthProvider {
  constructor(
    @Inject(REDIRECT_URL) private redirect: string,
    @Inject(AUTH_PROVIDERS) private pipeline: AuthProvider[],
    private idle: IdleService) { }

  isAuthenticated(): boolean {
    return !some(this.pipeline, p => !p.isAuthenticated());
  }

  signIn(username: string, password: string): Observable<User> {
    return Observable.combineLatest(
      this.pipeline
        .filter(f => f.signIn)
        .map(p => p.signIn(username, password)))
      .catch(response => {
        throw Observable.throw(response);
      })
      .map((users: User[]) => reduce(users, (user, val) => assign(user, val), {} as User))
      .map(user => isEmpty(user) ? null : new User(user));
  }

  signOut(): Observable<boolean> {
    return Observable.merge(...map(this.pipeline, p => p.signOut()));
  }

  refresh(local?: boolean): Observable<User> {
    return Observable.combineLatest(
      this.pipeline
        .filter(f => f.refresh)
        .map(p => p.refresh(local)))
      .map((users: User[]) => reduce(users, (user, val) => assign(user, val), {} as User))
      .map(user => isEmpty(user) ? null : new User(user));
  }

  intercept(request: HttpRequest<any>): HttpRequest<any> {
    return reduce(this.pipeline, (r, p) => p.intercept(r), request);
  }

  ping(): Observable<boolean> {
    return Observable.merge<boolean>(
      ...this.pipeline
        .filter(f => !!f.PING_TIMER)
        .map((p) => this.idle.onInterval(p.PING_TIMER)
          .switchMap(() => p.ping())));
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/auth/services/auth.service.ts